import React from 'react'
import classNames from 'classnames'

export default function ApplicantInput ({ name, id, prefix = '', ...props }) {
  return (
    <div className={'lc-applicant__input'}>
      <label htmlFor={id}>{name}</label>
      <div className={'lc-applicant__input-wrap'}>
        {prefix && <div className={'lc-applicant__input-prefix'}>{prefix}</div>}
        <input
          id={id}
          className={classNames('lc-applicant__input-element', {
            'lc-applicant__input-element--has-prefix': prefix
          })}
          {...props}
        />
      </div>
    </div>
  )
}
